import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 border-t border-navy-800" data-id="element-54" data-mp="32wd2cf6gdjt0">
      <div className="container mx-auto px-4" data-id="element-55" data-mp="3gfiyctkyyvje">
        <div className="max-w-4xl mx-auto text-center" data-id="element-56" data-mp="3ghc486nrdbqc">
          <p className="text-gray-400 font-medium mb-6" data-id="element-57" data-mp="32ovuyo49khgz">
            © 2026 Football Prêt : Système 365 — Tous droits réservés.
          </p>

          <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-58" data-mp="36nd1b5fv1nxc">
            Football Prêt : Système 365 est une ressource pédagogique destinée à
            accompagner les entraîneurs de football dans la planification,
            l'organisation et la conduite de leurs séances d'entraînement. Ce
            produit ne remplace pas une certification d'entraîneur officielle,
            les exigences de protection des mineurs, ni les réglementations des
            instances du football.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-59" data-mp="2eyt6sj3gzvnn">
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-60" data-mp="3l9k292unj58j">
              Conditions Générales
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-61" data-mp="3gb8wp4be3gw4">
              Politique de Confidentialité
            </a>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-62" data-mp="3v919hopjxr6m">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}